import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { UserType, } from '@models';
import { addToObjectIf } from '@utils/object.utils';
import { map } from 'rxjs/operators';
import { ODataService } from './generics/odata.service';
import { MapperService } from './mapper.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var FoldersService = /** @class */ (function (_super) {
    tslib_1.__extends(FoldersService, _super);
    function FoldersService(http) {
        var _this = _super.call(this, http, MapperService.foldersMap) || this;
        _this.hasSwitchCapability = true;
        _this._endpoint = '/odata/Folders';
        _this.addAdEntityToFolder = function (entity, folderId, roleIds) {
            var payload = {
                assignment: tslib_1.__assign({}, entity, { UserType: UserType[entity.UserType], RolesPerFolder: [tslib_1.__assign({ FolderId: folderId }, addToObjectIf(!!roleIds, {
                            RoleIds: roleIds,
                        }))] }),
            };
            return _this._http.post(_this._endpoint + "/UiPath.Server.Configuration.OData.AssignDomainUser", JSON.stringify(payload));
        };
        _this.getAllRolesForUser = function (_a) {
            var username = _a.username, _b = _a.skip, skip = _b === void 0 ? 0 : _b, _c = _a.take, take = _c === void 0 ? 10 : _c;
            return _this._http.get("api/FoldersNavigation/GetAllRolesForUser?username=" + encodeURIComponent(username) + "&skip=" + skip + "&take=" + take).pipe(map(function (res) { return _this._toDto(res, MapperService.userRolesMap); }));
        };
        return _this;
    }
    FoldersService.prototype.getFolderContext = function (folderId, take, relativeSkip) {
        var _this = this;
        return this._http.get("api/FoldersNavigation/GetFolderContext?relativeSkip=" + relativeSkip + "&take=" + take +
            (folderId != null
                ? "&folderId=" + folderId
                : ''))
            .pipe(map(function (r) { return r; }), map(function (_a) {
            var AncestorIds = _a.AncestorIds, IndexInAllFoldersList = _a.IndexInAllFoldersList, Count = _a.Count, PageItems = _a.PageItems;
            return ({
                ancestors: (AncestorIds || []),
                index: IndexInAllFoldersList,
                folders: (PageItems || []).map(function (item) { return _this._mapData(item); }),
                count: Count,
            });
        }));
    };
    FoldersService.prototype.getFolders = function (expandedIds, take, skip) {
        var _this = this;
        return this._http.get("api/FoldersNavigation/GetFoldersPageForCurrentUser?skip=" + skip + "&take=" + take +
            (expandedIds.length
                ? '&' + expandedIds.map(function (id) { return "expandedParentIds=" + id; }).join('&')
                : ''))
            .pipe(map(function (_a) {
            var PageItems = _a.PageItems, Count = _a.Count;
            return ({
                data: (PageItems || []).map(function (item) { return _this._mapData(item); }),
                total: Count,
            });
        }));
    };
    FoldersService.prototype.getQueryString = function (queryOptions) {
        // Extract ParentId from filters and add it as a separate query param.
        var filters = queryOptions &&
            queryOptions.filter &&
            queryOptions.filter.and &&
            queryOptions.filter.and instanceof Array &&
            queryOptions.filter.and;
        var parentIdFilterIndex = filters &&
            filters.findIndex(function (filter) { return filter.hasOwnProperty('ParentId'); });
        var parentId = null;
        if (filters &&
            parentIdFilterIndex !== -1) {
            parentId = filters[parentIdFilterIndex]
                .ParentId.eq;
        }
        var queryString = _super.prototype.getQueryString.call(this, queryOptions);
        if (parentId !== null) {
            queryString = queryString.indexOf('?') !== -1 ?
                queryString + "&parentId=" + parentId :
                queryString + "?parentId=" + parentId;
        }
        return queryString;
    };
    FoldersService.prototype.searchFolders = function (skip, take, searchText) {
        var _this = this;
        return this._http.get("api/FoldersNavigation/GetFoldersForCurrentUser?skip=" + skip + "&take=" + take + "&searchText=" + encodeURIComponent(searchText))
            .pipe(map(function (_a) {
            var PageItems = _a.PageItems, Count = _a.Count;
            return ({
                data: (PageItems || []).map(function (item) { return _this._mapData(item); }),
                total: Count,
            });
        }));
    };
    FoldersService.prototype.addUserToFolder = function (userId, folderId, roleIds) {
        var payload = {
            assignments: {
                UserIds: [userId],
                RolesPerFolder: [tslib_1.__assign({ FolderId: folderId }, addToObjectIf(!!roleIds, {
                        RoleIds: roleIds,
                    }))],
            },
        };
        return this._http.post(this._endpoint + "/UiPath.Server.Configuration.OData.AssignUsers", JSON.stringify(payload));
    };
    FoldersService.prototype.removeUserFromFolder = function (folderId, userId) {
        var payload = { userId: userId };
        return this._http.post(this._endpoint + "(" + folderId + ")/UiPath.Server.Configuration.OData.RemoveUserFromFolder", JSON.stringify(payload));
    };
    FoldersService.prototype.checkAssignedUser = function (folderId, username) {
        var _this = this;
        var queryOptions = {
            top: 1,
            filter: {
                'UserEntity/UserName': username,
            },
        };
        return this._http.get(this._endpoint + "/UiPath.Server.Configuration.OData.GetUsersForFolder(key=" + folderId + ",includeInherited=false)" +
            this.getQueryString(queryOptions)).pipe(map(function (res) { return _this._mapData(res, MapperService.folderAssignmentsMap); }), map(function (res) { return res.data[0]; }));
    };
    FoldersService.prototype.getAssignedUsers = function (folderId, includeInheritedUsers, queryOptions) {
        var _this = this;
        return this._http.get(this._endpoint + "/UiPath.Server.Configuration.OData.GetUsersForFolder" +
            ("(key=" + folderId + ",includeInherited=" + includeInheritedUsers + ")") +
            this.getQueryString(queryOptions)).pipe(map(function (res) { return _this._mapData(res, MapperService.folderAssignmentsMap); }));
    };
    FoldersService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FoldersService_Factory() { return new FoldersService(i0.ɵɵinject(i1.HttpClient)); }, token: FoldersService, providedIn: "root" });
    return FoldersService;
}(ODataService));
export { FoldersService };
